import { Injectable } from '@angular/core';
import { HttpClient} from "@angular/common/http";
import 'rxjs/add/operator/map';

import { environment } from '../../../environments/environment';

@Injectable()
export class EmployeeService {

    constructor(private http: HttpClient) {}

    all(req){
        req.activeSort = req.activeSort || 'id';
        req.sortDirection = req.sortDirection || 'asc';
        req.page = req.page || 1; //default first page
        req.perPage = req.perPage || 5; //default no limit
        req.filter = req.filter || '';

        let requestUrl = environment.apiUrl + 'employee/all';
        requestUrl += "?page=" + req.page + "&perPage=" + req.perPage + "&activeSort=" + req.activeSort + "&sortDirection=" + req.sortDirection + "&filter=" + req.filter;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    add(branch){
        let requestUrl = environment.apiUrl + 'employee/store';
        return this.http.post(requestUrl, branch).map( (res: any) => {
            return res;
        });
    }

    edit(branch){
        let requestUrl = environment.apiUrl + 'employee/update/' + branch.id;
        return this.http.put(requestUrl, branch).map( (res: any) => {
            return res;
        });
    }

    get(id){
        let requestUrl = environment.apiUrl + 'employee/get/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    delete(id){
        let requestUrl = environment.apiUrl + 'employee/delete/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

}



// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/shared/services/employee.service.ts